import * as React from "react";

import {isTruthy} from "@khanacademy/wonder-stuff-core";
import {hasDevFlag} from "@repo/shared-core";
import {useLocation} from "@repo/urls";

type ShowCourseUnitRevampContextType = {
    forceLegacy: boolean;
};

// Context so that components higher up the tree can override the revamp flag
// and force legacy rendering. This is necessary for CurationPages, at least.
export const ShowCourseUnitRevampContext: React.Context<ShowCourseUnitRevampContextType> =
    React.createContext<ShowCourseUnitRevampContextType>({forceLegacy: false});

export const useShowCourseUnitRevamp = (): boolean => {
    const {pathname} = useLocation();
    const {forceLegacy} = React.useContext(ShowCourseUnitRevampContext);
    const forceLegacyDevFlag = hasDevFlag("cl_cur_force_legacy");

    if (forceLegacy || forceLegacyDevFlag) {
        return false;
    }

    const pathParts = pathname.split("/").filter(isTruthy);
    const isDomain = pathParts.length === 1;
    const isExcludedPath = [
        // TX
        "/teacher/resources",
        "/teacher/resources/learning",
    ].includes(pathname);

    return !isDomain && !isExcludedPath;
};
